module.exports = __webpack_public_path__ + "media/images/placeholders/empfang-438e306f571213b9c4e8daa9df1b840b.jpg";